import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  content: {
    paddingRight: theme.spacing[5],
    paddingLeft: theme.spacing[5],
    paddingBottom: theme.spacing[10],
    backgroundColor: colors.backgroundL0,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing[8],
  },
  titleContainer: {
    flex: 1,
  },
  message: {
    marginBottom: theme.spacing[8],
  },
  buttonsContainer: {
    gap: theme.spacing[3],
  },
  cancelButton: {
    backgroundColor: colors.backgroundNegative,
    height: 50,
    borderRadius: theme.borderRadius.m,
    justifyContent: 'center',
    alignItems: 'center',
  },
  keepButton: {
    backgroundColor: 'transparent',
    height: 50,
    borderRadius: theme.borderRadius.m,
    borderWidth: 1.5,
    borderColor: colors.borderPrimary,
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
